/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import i from"./PointSizeAlgorithm.js";import t from"./PointSizeFixedSizeAlgorithm.js";import o from"./PointSizeSplatAlgorithm.js";const e={key:"type",base:i,typeMap:{"fixed-size":t,splat:o}};export{e as pointSizeAlgorithmTypes};
